import floatingInSpacePrintImage from "../../../image/originals/quantum/floating.webp";
import paradoxPrintImage from "../../../image/originals/quantum/paradox.webp";
import selenePrincessPrintImage from "../../../image/originals/quantum/Selene_Princess.webp";
import groundedForYouPrintImage from "../../../image/originals/quantum/GROUNDED.webp";
import twinFlamePrintImage from "../../../image/originals/quantum/twinFlame.webp";
import leapsPrintImage from "../../../image/originals/quantum/LEAPS.webp";
import risksPrintImage from "../../../image/originals/quantum/RISKS.webp";

import Collection from "../Collection";

const QuantumPrints = () => {
  const items = [
    {
      title: "Floating in Space Print",
      imageUrl: floatingInSpacePrintImage,
      projectUrl: "/FloatingInSpacePrint",
    },
    {
      title: "Paradox Print",
      imageUrl: paradoxPrintImage,
      projectUrl: "/ParadoxPrint",
    },
    {
      title: "Selene Princess Print",
      imageUrl: selenePrincessPrintImage,
      projectUrl: "/SelenePrincessPrint",
    },
    {
      title: "Grounded For You Print",
      imageUrl: groundedForYouPrintImage,
      projectUrl: "/GroundedForYouPrint",
    },
    {
      title: "Twin Flame Print",
      imageUrl: twinFlamePrintImage,
      projectUrl: "/TwinFlamePrint",
    },
    {
      title: "Leaps Print",
      imageUrl: leapsPrintImage,
      projectUrl: "/LeapsPrint",
    },
    {
      title: "Risks Print",
      imageUrl: risksPrintImage,
      projectUrl: "/RisksPrint",
    },
  ];

  return (
    <Collection
      items={items}
      title="Quantum Entanglement Prints"
      variant="boutique"
      eyebrow="Limited Edition Prints"
      description="A limited print series exploring connection, energy, and the space between souls."
      pageClassName="collection-page--prints"
      showFooter
    />
  );
};

export default QuantumPrints;
